import React from "react";
import AnimatedSvgThing from "../../animatedSvgBits/AnimatedSvgThing";

export default function VolumeMeter({
  ampVals,
  timings,
  progress,
  isTransparent,
}) {
  const avgAmp =
    ampVals.reduce((runningTotal, currVal) => runningTotal + currVal) /
    ampVals.length;

  // as a fraction
  const volume = avgAmp;

  const minRotation = -44;
  const maxRotation = 44;
  const range = maxRotation - minRotation;
  const currRotation = minRotation + range * volume;

  const outlineColour = "rgba(0,0,0,0.4)";
  const strokeWidth = 0.4;

  return (
    <g>
      <g strokeLinejoin="round" strokeLinecap="round">
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#111119"
          strokeWidth={strokeWidth}
          stroke={outlineColour}
          d="M102.116 99.865h24.468a5.94 5.94 0 015.953 5.953v22.145a5.94 5.94 0 01-5.953 5.953h-24.468a5.94 5.94 0 01-5.953-5.953v-22.145a5.94 5.94 0 015.953-5.953z"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#fff"
          strokeWidth={strokeWidth}
          stroke={outlineColour}
          d="M105.484 103.76h17.732a5.94 5.94 0 015.953 5.953v8.944a5.94 5.94 0 01-5.953 5.953h-17.732a5.94 5.94 0 01-5.953-5.953v-8.944a5.94 5.94 0 015.953-5.953z"
        />

        {/* NEEDLE */}
        <g opacity={1} transform={`rotate(${currRotation}, 114.33, 125.585)`}>
          <AnimatedSvgThing
            className={`tapeComponent ${isTransparent && "transparent"}`}
            type="path"
            timings={timings}
            progress={progress}
            fill="#fff"
            fillOpacity="0.606"
            strokeWidth={strokeWidth}
            stroke={outlineColour}
            d="M 114.33 125.585 l 0.04 -20.205"
          />
        </g>
        {/* END NEEDLE */}

        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#111119"
          strokeWidth={strokeWidth}
          stroke={outlineColour}
          d="M114.276 116.606a7.229 7.229 0 00-7.155 7.228 7.229 7.229 0 00.042.776h14.374a7.229 7.229 0 00.042-.776 7.229 7.229 0 00-7.229-7.228 7.229 7.229 0 00-.074 0z"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          fillRule="evenodd"
          strokeWidth={strokeWidth}
          stroke={outlineColour}
          d="M102.337 114.137c4.708-3.817 9.786-6.055 16.234-4.006"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          fillRule="evenodd"
          stroke="red"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M118.706 110.192c1.946.62 5.51 2.422 7.735 4.181"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#111119"
          stroke="none"
          d="M114.22 117.135a7.032 7.229 0 00-6.961 7.228 7.032 7.229 0 00.04.776h13.984a7.032 7.229 0 00.04-.776 7.032 7.229 0 00-7.032-7.228 7.032 7.229 0 00-.072 0z"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="#000"
          strokeWidth="0.265"
          d="M114.33 111.1l.04-3.603"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="#000"
          strokeWidth="0.265"
          d="M107.02 113.044l-1.766-3.14"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="#000"
          strokeWidth="0.265"
          d="M110.547 111.59l-.893-3.49"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="#000"
          strokeWidth="0.265"
          d="M118.11 111.604l.973-3.469"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="red"
          fillOpacity="0.606"
          stroke="red"
          strokeWidth="0.265"
          d="M118.11 111.604l.973-3.469"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="red"
          strokeWidth="0.265"
          d="M121.632 113.07l1.837-3.099"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="red"
          strokeWidth="0.265"
          d="M124.654 115.398l2.576-2.518"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="#000"
          fillOpacity="0.606"
          stroke="#000"
          strokeWidth="0.265"
          d="M103.99 115.36l-2.519-2.576"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          fillRule="evenodd"
          stroke="#ccc"
          strokeOpacity="1"
          strokeWidth="0.265"
          d="M108.384 128.879h11.932v.669h-11.932z"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          fillRule="evenodd"
          stroke="#ccc"
          strokeOpacity="1"
          strokeWidth="0.265"
          d="M110.872 130.344h6.957"
        />
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          timings={timings}
          progress={progress}
          fill="none"
          fillRule="evenodd"
          stroke="#ccc"
          strokeOpacity="1"
          strokeWidth="0.265"
          d="M112.09 131.036h4.52"
        />
      </g>
    </g>
  );
}
